/** Non-collaborator workspace roles that grant full workspace visibility. */
export const FULL_MEMBER_ROLES = [
  "primary_owner",
  "owner",
  "admin",
  "member",
] as const;

/** Workspace roles allowed to perform admin-level actions (manage members, channels, etc). */
export const ADMIN_PLUS: readonly string[] = [
  "primary_owner",
  "owner",
  "admin",
];
